import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { message } from "antd";
import { unlinkElement } from "../../../data/slices/linking";
import Button from "../../Button";
import Overlay from "../../Overlay";
import HeaderOverlay from "../../Project/Header";
import Title from "../../Project/Title";
import { useLocation } from "react-router-dom";
import { useFiltersAndDates } from "../../../hooks/useFiltersAndDate";

function LinkingDeleteConfirm({ open, id, handleClose, data }) {
  const dispatch = useDispatch();
  const { mode } = useSelector((state) => state.layout);
  const { unlinkStatus } = useSelector((state) => state.linking);
  const location = useLocation();

  const handleCloseFunc = (id) => {
    handleClose(id);
    data?.onCancel && data.onCancel();
  };

  const { constructFilters, getStartAndEndDate, getStartAndEndDateSynthesis } =
    useFiltersAndDates();

  const { footerConstructedFilters, tableConstructedFilters } =
    constructFilters();

  const { startDate, endDate } = getStartAndEndDate();
  const { startDateSynthesis, endDateSynthesis } =
    getStartAndEndDateSynthesis();

  const handleConfirm = async () => {
    try {
      const unlinkData = {
        elementId: data?.elementId,
        isListing: location.pathname.includes("listing"),
        listing: {
          params: { startDate, endDate, ...tableConstructedFilters },
          mode,
          projectId: data?.projectId,
        },
        isPlancompta: false,
        project: {
          projectId: data?.projectId,
          mode: mode,
          params: { startDate, endDate, ...tableConstructedFilters },
        },
        synthesis: {
          projectId: data?.projectId,
          mode: mode,
          params: {
            startDate: startDateSynthesis,
            endDate: endDateSynthesis,
            ...tableConstructedFilters,
          },
        },
        sum: {
          projectId: data?.projectId,
          mode: mode,
          params: { startDate, endDate, ...footerConstructedFilters },
        },
      };

      await dispatch(unlinkElement(unlinkData)).then((res) => {
        if (res.meta.requestStatus === "rejected") {
          message.error("Erreur lors de la suppression de la liaison");
          return;
        }

        message.success("La liaison a été supprimée avec succès");
        handleClose(id);
        data?.onConfirm && data.onConfirm();
      });
    } catch (error) {
      console.error("Error unlinking element:", error);
      message.error("Erreur lors de la suppression de la liaison");
    }
  };

  return (
    <Overlay show={open} closable={true} onClick={handleCloseFunc}>
      <HeaderOverlay showlogo>
        <Title
          isDelete
          projectTitle={
            <div style={{ width: "95%" }}>
              Êtes-vous sûr de vouloir supprimer cette liaison ? Cette action ne
              peut pas être annulée.
            </div>
          }
          subTitle={`Supprimer la liaison`}
        />
        <div className="verify-inputs-popup">
          <Button
            text={"Annuler"}
            onClick={() => handleCloseFunc(id)}
            className={"action-button"}
            style={{ width: "200px" }}
          />
          <Button
            text={"Supprimer"}
            onClick={handleConfirm}
            className={"action-button agree-action-button"}
            iconClassName={"delete-icon"}
            style={{ width: "200px" }}
            disabled={unlinkStatus === "loading"}
          />
        </div>
      </HeaderOverlay>
    </Overlay>
  );
}

export default LinkingDeleteConfirm;
